import {Component, OnInit} from '@angular/core';
import {ThemePalette} from '@angular/material/core';
import {MatDialog} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {AdresseModels} from 'src/app/models/adresse-models';
import {MainDataModels} from 'src/app/models/maindata-models';
import {DatumFormatPipe} from 'src/app/pipes/datum-format.pipe';
import {AdresseDataService} from 'src/app/services/adresse-data.service';
import {DashboardService} from 'src/app/services/dashboard.service';
import {MainDataService} from 'src/app/services/main-data.service';
import {MessageBoxService} from 'src/app/services/message-box.service';
import {ObjektDataService} from 'src/app/services/objekt-data.service';
import {SwissSettingsService} from 'src/app/services/swiss-settings.service';
import {v4 as uuidv4} from 'uuid';
import {NotizEintragComponent} from '../../pendenzen/notiz-eintrag/notiz-eintrag.component';
import {AdressEintragComponent} from '../adress-eintrag/adress-eintrag.component';
import {KontaktEintragComponent} from '../kontakt-eintrag/kontakt-eintrag.component';
import {SpeedDialItemEventArgs, SpeedDialItemModel,} from '@syncfusion/ej2-angular-buttons';
import {BenutzerModels} from 'src/app/models/benutzer-models';
import {UserAuthenticationService} from '../../../services/user-authentication.service';
import {HelperService} from '../../../services/helper.service';
import EmptyDetailAdresseElement = AdresseModels.EmptyDetailAdresseElement;

export interface Task {
    name: string;
    completed: boolean;
    color: ThemePalette;
    subtasks?: Task[];
}

@Component({
    selector: 'app-adressen-mobile', templateUrl: './adressen-mobile.component.html', styleUrls: ['./adressen-mobile.component.scss'],
})
export class AdressenMobileComponent implements OnInit {
    toggle = 'suchen';

    /* Logik-Start */
    dataSource: MatTableDataSource<AdresseModels.AddressListElement>;
    dbAnsprechPartner: AdresseModels.AnsprechPartnerListElement[] = [];
    dataSourceAnsprechPartner!: MatTableDataSource<AdresseModels.AnsprechPartnerListElement>;
    selectedAdressID = '';
    laender?: AdresseModels.Country[];
    adressStatus?: AdresseModels.AdressStatus[];
    hasAnsprechPartner = 0; // 0: nein | 1: ja
    public onlyActive = true;

    /* Expand-Status */
    expandStateAdresseSuchen = 0; // geöffnet
    expandStateAdresse = 1; // geschlossen
    expandStateAdressDetails = 1; // geschlossen
    expandStateAdressPartner = 1; // geschlossen
    expandStateObjektListe = 1; // geschlossen
    expandPanelHeaderExpandendHeight = '42px';
    expandPanelHeaderCollapsedHeight = '42px';
    allCompleteHauptAnsprechpartner = false;
    allCompletePersKontakt = false;
    currAdresse!: AdresseModels.DetailAdresseElement;
    currAnsprechPartner!: AdresseModels.AnsprechPartnerElement;
    selectedAnsprechAdressID = '';
    adresseList!: AdresseModels.AddressListElement[];
    filteredAdresseList!: AdresseModels.AddressListElement[];
    searchField!: any;
    allCompleteInaktiv = false;
    /* Objektliste */
    objektListFields: AdresseModels.ObjektListField[] = [];
    objektListe: AdresseModels.ObjektListElement[] = [];
    dataSourceObjektListe: MatTableDataSource<AdresseModels.ObjektListElement> = new MatTableDataSource();
    displayedObjektColumns: string[] = ['objectNo', 'typeDesc', 'desc', 'objekt'];
    hasObjekts = 0; // 0: nein | 1: ja
    selectedObjektID = '';

    /* Datenstatus */
    inEditAnsprechPartnerState = 0; // 0: nein | 1: ja
    // Berechtigungen
    public rechtAdresseLoeschen = false;
    /* ENDE Objketliste */
    public rechtAdresseMutieren = false;
    public rechtAdresseErstellen = false;
    /* Ansprechpartner bearbeiten */
    public anreden: AdresseModels.AddressSalutation[] = [];
    public briefAnreden: AdresseModels.AddressLetterSalutation[] = [];
    public briefAnredenAbgefuellt: AdresseModels.AddressLetterSalutation[] = [];
    public zuHanden: string[] = [];
    public zuHandenAbgefuellt: string[] = [];
    public menuItems: SpeedDialItemModel[] = [];
    prevToggleValue: string[] = ['suchen'];
    headerTitle = 'MOBILE_APP.ADDRESS.SEARCH_TITLE';
    headerObject = '';
    taskInaktiv: Task = {
        name: 'Inaktiv', completed: false, color: 'warn', subtasks: [{name: 'Primary', completed: false, color: 'primary'}, {name: 'Accent', completed: false, color: 'accent'}, {name: 'Warn', completed: false, color: 'warn'},],
    };
    taskErsteAdresszeile: Task = {
        name: 'Name 2 auf erster Adresszeile',
        completed: false,
        color: 'warn',
        subtasks: [{name: 'Primary', completed: false, color: 'primary'}, {name: 'Accent', completed: false, color: 'accent'}, {name: 'Warn', completed: false, color: 'warn'},],
    };
    taskHauptAnsprechpartner: Task = {
        name: 'ist Hautansprechparter', completed: false, color: 'warn', subtasks: [{name: 'Primary', completed: false, color: 'primary'}, {name: 'Accent', completed: false, color: 'accent'}, {name: 'Warn', completed: false, color: 'warn'},],
    };
    taskPersKontakt: Task = {
        name: 'persönlicher Kontakt', completed: false, color: 'warn', subtasks: [{name: 'Primary', completed: false, color: 'primary'}, {name: 'Accent', completed: false, color: 'accent'}, {name: 'Warn', completed: false, color: 'warn'},],
    };
    /* Start Checkbox Name 2 auf erster Adresszeile */
    allCompleteErsteAdresszeile = false;
    private filterValue = '';

    /* ENDE Ansprechpartner bearbeiten */
    private objektUrl = '/objekte-mobile';
    /* Neue Notiz erstellen */
    private dataForCalendarNote?: MainDataModels.NotizMitBenutzer;
    private currNotizMitBenutzern?: MainDataModels.NotizMitBenutzer;
    private vorname = '';
    private name = '';

    constructor(private svcAdressen: AdresseDataService, private userAuthService: UserAuthenticationService, private helperService: HelperService, private toastr: ToastrService, public dialog: MatDialog, private svcMainData: MainDataService, private svcMessageBox: MessageBoxService, private swissSettings: SwissSettingsService, private svcObjektData: ObjektDataService, private svcDashboard: DashboardService, private _datumFormatPipe: DatumFormatPipe, private router: Router, private route: ActivatedRoute) {
        this.helperService.setPageRefreshURL('/adressen-mobile').then(() => {
            if (this.userAuthService.getCurrentAuthenticatedUser() == undefined) {
                this.router.navigate(['']);
            }
        });
        this.dataSource = new MatTableDataSource<AdresseModels.AddressListElement>();

        this.dataSourceAnsprechPartner = new MatTableDataSource<AdresseModels.AnsprechPartnerListElement>();

        this.currAdresse = AdresseModels.EmptyDetailAdresseElement(this.svcAdressen.getDefaultCountry());
        this.currAnsprechPartner = this.initCurrAnsprechPartner();

        this.initUserRights();
    }

    ngOnInit(): void {
        this.svcAdressen.getCountries().subscribe({
            next: (res: AdresseModels.Country[] | undefined) => {
                this.laender = res;
            },
        });

        this.svcAdressen.getAdressStatus().subscribe({
            next: (res: AdresseModels.AdressStatus[] | undefined) => {
                this.adressStatus = res;
            },
        });

        this.reloadAdressen();

        this.route.params.subscribe({
            next: (params) => {
                if (params.id) {
                    this.selectedAdressID = params.id;
                    this.loadSingleAdresse();
                    this.toggleBtn('adressansicht');
                }
            },
        });
    }

    back() {
        // current page
        this.prevToggleValue.pop();
        // last page
        const prev = this.prevToggleValue.pop();
        if (prev) {
            this.toggleBtn(prev);
        }
    }

    public speedMenuClicked(args: SpeedDialItemEventArgs): void {
        switch (args.item.id) {
            case (args.item.id = 'create.adddress'):
                this.onNewAddress();
                break;
            case (args.item.id = 'log.out'):
                this.userAuthService.logoutUser('/login');
                break;

            default:
                return;
        }
    }

    // todo by language code
    public speedMenuCreated(): void {
        this.menuItems = [];
        this.menuItems.push({text: 'Abmelden', id: 'log.out'});
    }

    reloadAdressen() {
        // Adressen für Adressensuche ermitteln
        this.svcAdressen.getAdressen().subscribe({
            next: (res: AdresseModels.AddressListElement[]) => {
                this.adresseList = res;

                if (this.onlyActive) {
                    this.filteredAdresseList = this.adresseList.filter((ale) => !ale.inaktiv);
                } else {
                    this.filteredAdresseList = this.adresseList;
                }
                // Falls schon ein Suchbegriff eingegeben wurde, diesen nochmals verwenden
                if (this.filterValue) {
                    if (this.selectedAdressID) {
                        if (this.adresseList.findIndex((ale) => ale.adressID === this.selectedAdressID) < 0) {
                            this.selectedAdressID = '';
                        }
                    }
                }
            },
        });

        this.svcAdressen.getAnreden(true).subscribe({
            next: (res: AdresseModels.AddressSalutation[]) => {
                this.anreden = res;
            }, error: (error: any) => console.error('Fehler beim Ermitteln der Kontakt-Anreden.', error),
        });

        this.svcAdressen.getBriefanreden(true).subscribe({
            next: (res: AdresseModels.AddressLetterSalutation[]) => {
                this.briefAnreden = res;
                this.genBriefanreden();
            }, error: (error: any) => console.error('Fehler beim Ermitteln der Kontakt-Briefanreden.', error),
        });

        this.svcAdressen.getZuHanden(true).then(res => {
            this.zuHanden = res;
        });
    }

    applyFilter(value: any) {
        this.filterValue = value.trim().toLowerCase();

        this.filteredAdresseList = this.adresseList.filter((el) => {
            return (el.firstName.toLowerCase().includes(this.filterValue) || el.lastName.toLowerCase().includes(this.filterValue) || el.street1.toLowerCase().includes(this.filterValue) || el.zip.toLowerCase().includes(this.filterValue) || el.city.toLowerCase().includes(this.filterValue));
        });
    }

    clearInput() {
        this.searchField = '';
        this.filteredAdresseList = this.adresseList;
    }

    setActive() {
        this.onlyActive = !this.onlyActive;
        this.reloadAdressen();
    }

    highlight(row: any) {
        this.selectedAdressID = row.adressID;
        this.loadSingleAdresse();
    }

    loadSingleAdresse() {
        this.svcAdressen.getAddressByID(this.selectedAdressID).then(res => {
            this.currAdresse = res;
            this.setExpandStateAdresseSuchen(1);
            this.setExpandStateAdresse(0);
            this.updateAllCompleteErsteAdresszeile(); // Checkbox "Name 2 auf erster Adresszeile" setzen
            this.reloadAnsprechpartner();
            this.reloadObjektList();

            if (this.currAdresse.countryISOShort != '' && this.laender) {
                this.currAdresse.country = this.laender.filter((country) => country.isoShort === this.currAdresse.countryISOShort)[0];
            }

            if (this.swissSettings.getWebConfig().debugMode) {
                console.log('AdressDeteail', this.currAdresse);
            }
        }).catch(() => console.error('Die Adresse konnte nicht ermittelt werden'));
    }

    setAllInaktiv(completed: boolean) {
        this.currAdresse.status = completed ? 1 : 0;
        this.allCompleteInaktiv = completed;
        this.saveAddress();
    }

    modelChangeFn(e: any, source: string = '') {
        if (source === 'Land') {
            this.currAdresse.country = this.laender!.filter((l) => l.isoShort === e)[0];
            this.currAdresse.countryISOShort = this.currAdresse.country.isoShort;
        }
        if (source === 'LandKuerzel') {
            const countryIndex = this.laender!.findIndex((l) => l.isoShort === e);
            if (countryIndex >= 0) {
                this.currAdresse.country = this.laender![countryIndex];
                this.currAdresse.countryISOShort = this.currAdresse.country.isoShort;
            }
        }

        if (this.currAdresse.lastName != '' && this.currAdresse.zip != '' && this.currAdresse.city != '') {
            this.saveAddress();
        }
    }

    saveAddress() {
        // Neue oder bestehende Adresse wird gespeichert
        if (this.currAdresse.adressID == '') {
            this.currAdresse.adressID = uuidv4();
            this.svcAdressen.newAdresse(this.currAdresse).subscribe({
                next: (res) => {
                    if (this.swissSettings.getWebConfig().debugMode) {
                        console.log(res);
                    }
                    this.svcMessageBox.showSuccess('Die neue Adresse wurde erfolgreich gespeichert. ', 'Erfolgreich');
                    this.selectedAdressID = this.currAdresse.adressID;
                    this.reloadAdressen();
                    this.loadSingleAdresse();
                }, error: (err) => console.error(err),
            });
        } else {
            this.svcAdressen.updateAdresse(this.currAdresse).subscribe({
                next: (res) => {
                    console.log(res);
                    if (this.swissSettings.getWebConfig().debugMode) {
                        console.log(res);
                    }
                    this.svcMessageBox.showSuccess('Adresse erfolgreich aktualisiert ', 'Erfolgreich');
                }, error: (err) => {
                    console.error('Fehler beim Aktualisieren einer Adresse: ', err);
                    this.svcMessageBox.showError('⚠️ ❗❗ Die Adresse konnte nicht aktualisiert werden. ❗❗ ⚠️', '!! FEHLER !!');
                },
            });
        }
    }

    delAnsprechpartner(element: AdresseModels.AnsprechPartnerListElement) {
        console.log('Del Ansprechpartner', element);

        if (element.adressID != '') {
            this.svcMessageBox
                .askYesNoQuestion('MAIN_APP_DIALOG.DEL_CONTACT.msg', 'MAIN_APP_DIALOG.DEL_CONTACT.title', [element.name])
                .then((value) => {
                    if (value) {
                        this.svcAdressen.deleteAdressPartner(element.adressID).subscribe({
                            next: () => {
                                this.reloadAnsprechpartner();
                            }, error: (err) => {
                                console.error('Ansprechpartner konnte nicht gelöscht werden: ', err);
                                this.svcMessageBox.showError('Der Ansprechpartner konnte nicht gelöscht werden: ' + err, '!! FEHLER !!');
                            },
                        });
                    }
                });
        }
    }

    editAnsprechpartner(element: AdresseModels.AnsprechPartnerListElement) {
        console.log('Edit Ansprechpartner', element);
        this.currAnsprechPartner.adressID = element.adressID;
        this.currAnsprechPartner.adressNo = element.adressNr;
        this.currAnsprechPartner.hauptAnsprechpartner = element.hauptAnsprechpartner;
        this.allCompleteHauptAnsprechpartner = this.currAnsprechPartner.hauptAnsprechpartner === 1;
        this.currAnsprechPartner.lastName = element.name;
        this.name = element.name;
        this.currAnsprechPartner.firstName = element.vorname;
        this.vorname = element.vorname;
        this.currAnsprechPartner.ansprechInfo = element.ansprechInfo;
        this.currAnsprechPartner.anrede = element.anrede;
        this.currAnsprechPartner.briefanrede = element.briefanrede;
        this.currAnsprechPartner.zuhanden = element.zuhanden;
        this.currAnsprechPartner.telefon = element.telefon;
        this.currAnsprechPartner.mobile = element.natel;
        this.currAnsprechPartner.email = element.email;
        this.currAnsprechPartner.homepage = element.homepage;
        this.currAnsprechPartner.pers = element.pers;
        this.allCompletePersKontakt = this.currAnsprechPartner.pers === 1;
        this.inEditAnsprechPartnerState = 1; // Felder für die Bearbeitung werden eingeblendet
        this.hasAnsprechPartner = 0; // Ansprechpartner werden ausgeblendet
        this.genBriefanreden();
    }

    modelChangeAPFn() {
        if (this.currAnsprechPartner.lastName != '' && this.currAnsprechPartner.anrede != '' && this.currAnsprechPartner.briefanrede != '' && this.currAnsprechPartner.zuhanden != '') {
            const index = this.dataSourceAnsprechPartner.data.findIndex((ap) => ap.adressID === this.currAnsprechPartner.adressID);
            if (index >= 0) {
                this.dataSourceAnsprechPartner.data[index] = {
                    adressID: this.currAnsprechPartner.adressID,
                    adressNr: this.currAnsprechPartner.adressNo,
                    hauptAnsprechpartner: this.currAnsprechPartner.hauptAnsprechpartner,
                    name: this.currAnsprechPartner.lastName,
                    vorname: this.currAnsprechPartner.firstName,
                    ansprechInfo: this.currAnsprechPartner.ansprechInfo,
                    anrede: this.currAnsprechPartner.anrede,
                    briefanrede: this.currAnsprechPartner.briefanrede,
                    zuhanden: this.currAnsprechPartner.zuhanden,
                    telefon: this.currAnsprechPartner.telefon,
                    natel: this.currAnsprechPartner.mobile,
                    email: this.currAnsprechPartner.email,
                    homepage: this.currAnsprechPartner.homepage,
                    pers: this.currAnsprechPartner.pers,
                };
            }

            this.savePartner();
        }
    }

    delAddress() {
        if (this.currAdresse.adressID != '') {
            this.svcMessageBox.askYesNoQuestion('MAIN_APP_DIALOG.DEL_ADDRESS.msg', 'MAIN_APP_DIALOG.DEL_ADDRESS.title', [this.currAdresse.lastName]).then(async (value) => {
                if (value) {
                    try {
                        await this.svcAdressen.deleteAddress(this.currAdresse);
                        this.reloadAdressen();
                        this.currAdresse = EmptyDetailAdresseElement({isoCurrency: '', isoLanguage: '', isoShort: '', isoNameNational: '', isoNameInternational: ''});
                        this.setExpandStateAdresseSuchen(0);
                        this.setExpandStateAdresse(1);
                        this.setExpandStateAdressDetails(1);
                        this.setExpandStateAdressPartner(1);
                    } catch (exception) {
                        this.svcMessageBox.showErrorOK('MAIN_APP_DIALOG.DEL_ADDRESS.CONNECTED_ENTITIES.text', 'MAIN_APP_DIALOG.DEL_ADDRESS.CONNECTED_ENTITIES.title');
                    }
                }
            });
        }
    }

    onNewAddress() {
        // Werte initialisieren
        this.currAdresse = AdresseModels.EmptyDetailAdresseElement(this.svcAdressen.getDefaultCountry());

        const dialogRef = this.dialog.open(AdressEintragComponent, {
            disableClose: true, data: this.currAdresse,
        });

        return dialogRef.afterClosed().subscribe({
            next: (result) => {
                if (result) {
                    this.currAdresse = result;
                    if (this.swissSettings.getWebConfig().debugMode) {
                        console.log('Adresse vor Speicherung', this.currAdresse);
                    }
                    if (this.currAdresse) {
                        this.saveAddress();
                        this.setExpandStateAdressDetails(1);
                    }
                }
            },
        });
    }

    onNewPartner() {
        // Werte initialisieren
        this.currAnsprechPartner = this.initCurrAnsprechPartner();

        const dialogRef = this.dialog.open(KontaktEintragComponent, {
            disableClose: true, data: this.currAnsprechPartner,
        });

        return dialogRef.afterClosed().subscribe({
            next: (result) => {
                if (result) {
                    this.currAnsprechPartner = result;

                    if (this.currAnsprechPartner) {
                        this.savePartner();
                        this.setExpandStateAdressDetails(1);
                        this.inEditAnsprechPartnerState = 1; // Bearbeitenmaske wird eingeblendet
                        this.hasAnsprechPartner = 0; // Ansprechpartner werden ausgeblendet
                    }
                }
            },
        });
    }

    savePartner() {
        if (this.currAnsprechPartner.adressID == '') {
            this.currAnsprechPartner.adressID = uuidv4();
            this.svcAdressen
                .newAdressPartner(this.currAnsprechPartner, this.currAdresse.adressID)
                .subscribe({
                    next: (res) => {
                        console.log(res);
                        this.svcMessageBox.showSuccess('Der Ansprechpartner wurde erfolgreich gespeichert. ', 'Erfolgreich');

                        this.inEditAnsprechPartnerState = 0;
                        this.reloadAnsprechpartner();
                    }, error: (err) => console.error(err),
                });
        } else {
            this.svcAdressen
                .updateAdressPartner(this.dataSourceAnsprechPartner.data, this.currAdresse.adressID)
                .subscribe({
                    next: (res) => {
                        console.log(res);
                    }, error: (err) => console.log(err),
                });
        }
    }

    setExpandStateObjektListe(index: number) {
        this.expandStateObjektListe = index;
    }

    readPropertyCaseInsensitive(element: AdresseModels.ObjektListElement, prop: string) {
        prop = (prop + '').toLowerCase();
        for (const p in element) {
            if (element.hasOwnProperty(p) && prop == (p + '').toLowerCase()) {
                let value = (element as any)[p];

                if (p.toLowerCase() === 'created' || p.toLowerCase() === 'modified') {
                    value = this._datumFormatPipe.transform(value);
                } else if (p.toLowerCase() === 'typenumber') {
                    switch (value) {
                        case 1:
                            value = 'building_storage.png';
                            break;
                        case 2:
                            value = 'book.png';
                            break;
                        case 3:
                            value = 'folder_open.png';
                            break;
                        case 4:
                            value = 'book_open.png';
                            break;
                        case 5:
                            value = 'supplier.png';
                            break;
                        case 6:
                            value = 'people-worker-filled.png';
                            break;
                        case 7:
                            value = 'people-man-7-filled.png';
                            break;
                        default:
                            value = 'unknown_type.png';
                    }
                }
                return value;
            }
        }
    }

    openObjekt(row: any) {
        this.selectedObjektID = row.objectID;
        if (this.selectedObjektID) {
            this.router.navigate([this.objektUrl, this.selectedObjektID]);
        }
    }

    async genBriefanreden() {
        // Hier werden die originalen Briefanreden mit Platzhaltern in das anzuzeigende Array kopiert
        this.briefAnredenAbgefuellt = [];
        this.briefAnreden.forEach((val) => this.briefAnredenAbgefuellt?.push(Object.assign({}, val)));

        // Hier werden die Platzhalter im Array ersetzt (Nachname)
        if (this.briefAnredenAbgefuellt) {
            this.briefAnredenAbgefuellt.forEach((briefAnredObj, index) => {
                if (briefAnredObj) {
                    if (briefAnredObj.briefanrede.includes('%2')) {
                        // Name
                        if (this.name) {
                            briefAnredObj.briefanrede = briefAnredObj.briefanrede.replace('%2', this.name);
                        } else {
                            briefAnredObj.briefanrede = briefAnredObj.briefanrede.replace('%2', '');
                        }
                        this.briefAnredenAbgefuellt[index] = briefAnredObj;
                    }

                    if (briefAnredObj.briefanrede.includes('%1')) {
                        // Vorname
                        if (this.vorname) {
                            briefAnredObj.briefanrede = briefAnredObj.briefanrede.replace('%1', this.vorname);
                        } else {
                            briefAnredObj.briefanrede = briefAnredObj.briefanrede.replace('%1', '');
                        }
                        this.briefAnredenAbgefuellt[index] = briefAnredObj;
                    }
                }
            });
        }

        // zuHanden - Auswahl erstellen
        this.zuHandenAbgefuellt = [];
        this.zuHanden.forEach((a) => {
            if (this.vorname && this.name) {
                this.zuHandenAbgefuellt.push(a + ' ' + this.vorname + ' ' + this.name);
            } else if (this.name) {
                this.zuHandenAbgefuellt.push(a + ' ' + this.name);
            } else {
                this.zuHandenAbgefuellt.push(a);
            }
        });
    }

    /* Checkbox - Start */

    onVornameChange(event: Event) {
        this.vorname = (event.target as HTMLInputElement).value;
        this.genBriefanreden();
    }

    onNameChange(event: Event) {
        this.name = (event.target as HTMLInputElement).value;
        this.genBriefanreden();
    }

    updateAllCompletePersKontakt() {
        this.allCompletePersKontakt = this.currAnsprechPartner.pers != null && this.currAnsprechPartner.pers == 1;
    }

    someCompletePersKontakt(): boolean {
        if (this.taskPersKontakt.subtasks == null) {
            return false;
        }
        return (this.taskPersKontakt.subtasks.filter((t) => t.completed).length > 0 && !this.allCompletePersKontakt);
    }

    setAllPersKontakt(completed: boolean) {
        this.currAnsprechPartner.pers = completed ? 1 : 0;
        this.allCompletePersKontakt = completed;
        if (this.taskPersKontakt.subtasks == null) {
            return;
        }
        this.taskPersKontakt.subtasks.forEach((t) => (t.completed = completed));
        this.modelChangeAPFn();
    }

    /* Start Checkbox HauptAnsprechpartner */
    updateAllCompleteHauptAnsprechpartner() {
        this.allCompleteHauptAnsprechpartner = this.currAnsprechPartner.hauptAnsprechpartner != null && this.currAnsprechPartner.hauptAnsprechpartner == 1;
    }

    someCompleteHauptAnsprechpartner(): boolean {
        if (this.taskHauptAnsprechpartner.subtasks == null) {
            return false;
        }
        return (this.taskHauptAnsprechpartner.subtasks.filter((t) => t.completed).length > 0 && !this.allCompleteHauptAnsprechpartner);
    }

    setAllHauptAnsprechpartner(completed: boolean) {
        this.currAnsprechPartner.hauptAnsprechpartner = completed ? 1 : 0;
        this.allCompleteHauptAnsprechpartner = completed;
        if (this.taskHauptAnsprechpartner.subtasks == null) {
            return;
        }
        this.taskHauptAnsprechpartner.subtasks.forEach((t) => (t.completed = completed));
        this.modelChangeAPFn();
    }

    logout(): void {
        this.userAuthService.logoutUser('/login');
    }

    onAnredeChange(anrede: AdresseModels.AddressSalutation) {
        this.currAnsprechPartner.anrede = anrede.anrede;
        this.modelChangeAPFn();
    }

    onBriefanredeChange(briefAnrede: AdresseModels.AddressLetterSalutation) {
        this.currAnsprechPartner.briefanrede = briefAnrede.briefanrede;
        this.modelChangeAPFn();
    }

    onZuHandenChange(zuHanden: string) {
        this.currAnsprechPartner.zuhanden = zuHanden;
        this.modelChangeAPFn();
    }

    InitNeueNotiz() {
        const user = this.userAuthService.getCurrentAuthenticatedUser()!;
        this.dataForCalendarNote = {
            notiz: {
                noteID: uuidv4(),
                objectID: '',
                objDesc: '',
                adressID: undefined,
                contactID: undefined,
                responsible: user.loginname,
                created: new Date(),
                createdBy: user.loginname,
                modified: new Date(),
                modifiedBy: user.loginname,
                notes: '',
                description: '',
                done: 0,
                private: false,
                wasRead: 0,
            }, mitarbeiter: [], notizKategorien: [], istNeueNotiz: true,
        };
    }

    neueNotiz() {
        this.InitNeueNotiz();
        const objectID = this.svcObjektData.getCurrentObjectID();

        if (objectID) {
            this.dataForCalendarNote!.notiz.objectID = objectID;
        }

        this.dialog.open(NotizEintragComponent, {
            disableClose: true, width: '900px !important', data: this.dataForCalendarNote,
        }).afterClosed().subscribe({
            next: (result) => {
                if (result) {
                    this.currNotizMitBenutzern = result;
                    if (this.currNotizMitBenutzern) {
                        this.svcMainData.saveNotiz(this.currNotizMitBenutzern).subscribe({
                            next: () => {
                                this.svcMessageBox.showSuccess('Die Notiz wurde erfolgreich gespeichert.', 'Erfolgreich');
                                this.svcObjektData.reloadObjActivities();
                                this.svcDashboard.reloadDashboardBadgeIcons();
                                this.svcMainData.refreshNoteCount();
                            }, error: (error) => {
                                console.log(error);
                                this.svcMessageBox.showError('Die Notiz konnte nicht gespeichert werden!!', '!! FEHLER !!');
                            },
                        });
                    }
                }
            },
        });
    }

    someCompleteInaktiv(): boolean {
        if (this.taskInaktiv.subtasks == null) {
            return false;
        }
        return (this.taskInaktiv.subtasks.filter((t) => t.completed).length > 0 && !this.allCompleteInaktiv);
    }

    setExpandStateAdresseSuchen(index: number) {
        this.expandStateAdresseSuchen = index;
    }

    setExpandStateAdresse(index: number) {
        this.expandStateAdresse = index;
    }

    setExpandStateAdressDetails(index: number) {
        this.expandStateAdressDetails = index;
    }

    setExpandStateAdressPartner(index: number) {
        this.expandStateAdressPartner = index;
    }

    updateAllCompleteErsteAdresszeile() {
        this.allCompleteErsteAdresszeile = this.currAdresse.name2First != null && this.currAdresse.name2First == 1;
    }

    someCompleteErsteAdresszeile(): boolean {
        if (this.taskErsteAdresszeile.subtasks == null) {
            return false;
        }
        return (this.taskErsteAdresszeile.subtasks.filter((t) => t.completed).length > 0 && !this.allCompleteErsteAdresszeile);
    }

    setAllErsteAdresszeile(completed: boolean) {
        this.currAdresse.name2First = completed ? 1 : 0;
        this.allCompleteErsteAdresszeile = completed;
        if (this.taskErsteAdresszeile.subtasks == null) {
            return;
        }
        this.taskErsteAdresszeile.subtasks.forEach((t) => (t.completed = completed));
        this.saveAddress();
    }

    toggleBtn(value: string) {
        if (!this.selectedAdressID) {
            this.toastr.error('Bitte Adresse markieren');
            return;
        }
        this.prevToggleValue.push(value);
        switch (value) {
            case 'ansprechpartner':
                this.toggle = 'ansprechpartner';
                this.headerTitle = 'MOBILE_APP.ADDRESS.CONTACT_TITLE';
                this.headerObject = this.currAnsprechPartner.firstName + ' ' + this.currAnsprechPartner.lastName;
                break;
            case 'mutieren-adresse':
                this.headerTitle = 'MOBILE_APP.ADDRESS.MUTATION_ADDRESS_TITLE';
                this.headerObject = this.currAdresse.lastName;
                this.toggle = 'mutieren-adresse';
                break;
            case 'mutieren-ansprechpartner':
                this.headerTitle = 'MOBILE_APP.ADDRESS.MUTATION_CONTACT_TITLE';
                this.headerObject = this.currAnsprechPartner.firstName + ' ' + this.currAnsprechPartner.lastName;
                this.toggle = 'mutieren-ansprechpartner';
                break;
            case 'address-aktivitat':
                this.headerTitle = 'MOBILE_APP.ADDRESS.ACTIVITY_TITLE';
                this.headerObject = this.currAdresse.lastName;
                this.toggle = 'address-aktivitat';
                break;
            case 'teilen':
                this.headerTitle = 'MOBILE_APP.ADDRESS.SHARE_TITLE';
                this.headerObject = this.currAdresse.lastName;
                this.toggle = 'teilen';
                break;
            case 'objektliste':
                this.headerTitle = 'MOBILE_APP.ADDRESS.OBJECT_LIST_TITLE';
                this.headerObject = this.currAdresse.lastName;
                this.toggle = 'objektliste';
                break;
            case 'adressansicht':
                this.headerTitle = 'MOBILE_APP.ADDRESS.VIEW_TITLE';
                this.headerObject = this.currAdresse.lastName;
                this.toggle = 'adressansicht';
                break;
            default:
                this.headerTitle = 'MOBILE_APP.ADDRESS.SEARCH_TITLE';
                this.headerObject = '';
                this.toggle = 'suchen';
        }
    }

    private initUserRights() {
        this.rechtAdresseErstellen = this.userAuthService.getRight(BenutzerModels.UserRightCodes.AdresseErstellen);
        this.rechtAdresseMutieren = this.userAuthService.getRight(BenutzerModels.UserRightCodes.AdresseMutieren);
        this.rechtAdresseLoeschen = this.userAuthService.getRight(BenutzerModels.UserRightCodes.AdresseLoeschen);
    }

    private reloadObjektList() {
        // Objektliste der aktuellen Adresse laden
        this.svcAdressen.getObjectList(this.currAdresse.adressID).then(res => {
            this.objektListe = res;
            this.dataSourceObjektListe!.data = res;
            this.hasObjekts = 0;
            if (this.dataSourceObjektListe.data.length > 0) {
                this.hasObjekts = 1;
            }

            if (this.hasObjekts === 1) {
                this.setExpandStateObjektListe(0);
            } else {
                this.setExpandStateObjektListe(1);
            }
        }).catch(() => console.error('Die Objekte konnten nicht ermittelt werden'));
    }

    private async reloadAnsprechpartner() {
        // Ansprechspartner der aktuellen Adresse laden
        try {
            this.dbAnsprechPartner = await this.svcAdressen.getAnsprechpartnerByID(this.selectedAdressID);

            this.dataSourceAnsprechPartner!.data = this.dbAnsprechPartner;

            this.hasAnsprechPartner = 0;
            if (this.dataSourceAnsprechPartner.data.length > 0) {
                this.hasAnsprechPartner = 1;
            }
        } catch {
            this.toastr.error('Die Ansprechpartner konnten nicht geladen werden');
        }
    }

    private initCurrAnsprechPartner(): AdresseModels.AnsprechPartnerElement {
        this.currAnsprechPartner = {
            adressID: '', adressNo: 0, hauptAnsprechpartner: 0, lastName: '', firstName: '', ansprechInfo: '', anrede: '', briefanrede: '', zuhanden: '', telefon: '', mobile: '', email: '', homepage: '', pers: 0,
        };
        return this.currAnsprechPartner;
    }
}
